"use strict";

class TweenHelpers {

	static animateVector3(vectorToAnimate, target, options){

		options = options || {};
		// get targets from options or set to defaults
		var to = target || THREE.Vector3(),
			easing = options.easing || TWEEN.Easing.Quadratic.In,
			duration = options.duration || 2000;
		// create the tween
		var tweenVector3 = new TWEEN.Tween(vectorToAnimate)
			.to({ x: to.x, y: to.y, z: to.z, }, duration)
			.easing(easing)
			.onUpdate(function(d) {
				if(options.update){ 
					options.update(d);
				}
			})
			.onComplete(function(){
				if(options.callback) options.callback();
			});
		// start the tween
		tweenVector3.start();
		// return the tween in case we want to manipulate it later on
		return tweenVector3;
	}

	static animateFloat(floatToAnimate, target, options){

		options = options || {};
		// get targets from options or set to defaults
		var to = target || 1.0,
			easing = options.easing || TWEEN.Easing.Quadratic.In,
			duration = options.duration || 2000;
		// create the tween
		var tweenFloat = new TWEEN.Tween({value: floatToAnimate})
			.to({value: target}, duration)
			.easing(easing)
			.onUpdate(function(d) {
				if(options.update){
					options.update(d);
				}
			})
			.onComplete(function(){
				if(options.callback) options.callback();
			});
		// start the tween
		tweenFloat.start();
		// return the tween in case we want to manipulate it later on
		return tweenFloat;
	}

	static trackOriginalOpacities(mesh) {

		var opacities = [], 
			materials = mesh.material.materials ? mesh.material.materials : [mesh.material];
		for (var i = 0; i < materials.length; i++) {        
			materials[i].transparent = true;
			opacities.push(materials[i].opacity);
		}
		mesh.userData.originalOpacities = opacities;
	}
	
	static fadeMesh(mesh, direction, options) {

		options = options || {};
		// set and check 
		var current = { percentage : direction == "out" ? 1 : 0 },
		// this check is used to work with normal and multi materials.
		mats = mesh.material.materials ? 
			mesh.material.materials : [mesh.material],

		originals = mesh.userData.originalOpacities,
		easing = options.easing || TWEEN.Easing.Linear.None,
		duration = options.duration || 2000;
		// check to make sure originals exist
		if( !originals ) {
			console.error("Fade error: originalOpacities not defined, use trackOriginalOpacities");
			return;
		}
		// tween opacity back to originals
		var tweenOpacity = new TWEEN.Tween(current)
			.to({ percentage: direction == "out" ? 0 : 1 }, duration)
			.easing(easing)
			.onUpdate(function() {
				for (var i = 0; i < mats.length; i++) {
					mats[i].opacity = originals[i] * current.percentage;
				}
			})
		 .onComplete(function(){
			if(options.callback){
				options.callback();
			}
		 });
		tweenOpacity.start();
		return tweenOpacity;
	}

}